export const POINTS = { progress: 10, home: 50, lady: 200, fly: 200, board: 1000, beat: 10, extraLife: 20_000 } as const;
export const scoreDisplay = (score: number): string => String(Math.floor(score / 10) * 10 % 100_000).padStart(5, '0');
export function progressPoints(row: number, furthest: number): number {
  if (row <= furthest || row < 1 || row > 11 || row === 6) return 0;
  return POINTS.progress;
}
